import React, { useState, useEffect } from 'react';
import { t } from '../lib/i18n';
import Icon from './Icon';

export default function OfflineBanner() {
    const [offline, setOffline] = useState(!navigator.onLine);

    useEffect(() => {
        const goOff = () => setOffline(true);
        const goOn = () => setOffline(false);
        window.addEventListener('offline', goOff);
        window.addEventListener('online', goOn);
        return () => {
            window.removeEventListener('offline', goOff);
            window.removeEventListener('online', goOn);
        };
    }, []);

    if (!offline) return null;

    return (
        <div className="fixed top-0 left-0 right-0 z-[60] bg-red-600 text-white text-center text-sm py-2 font-medium shadow-lg" role="alert">
            <span className="inline-flex items-center gap-2"><Icon name="wifi-off" className="w-4 h-4" /> {t('offline_banner')}</span>
        </div>
    );
}
